var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.remote") } },
    [
      _c("el-switch", {
        on: { change: _vm.onRemoteChange },
        model: {
          value: _vm.optionModel.remote,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "remote", $$v)
          },
          expression: "optionModel.remote",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }